import { Component, Input, Output, EventEmitter, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { TaskRoutes } from '@task-utils/routes';
import { Task } from '@task-utils/types';
import { Frame, language, notification, color } from 'curvy';
import { label_flags_translations } from './label-flags.trans';
import { orders_translations } from '@task-modules/orders';
import { User } from '@task-modules/users';

export type LABEL_FLAG = Partial<Task.LabelFlags> & {
    company_id?: number | null;
    label_id?: number;
};

@Component({
    selector: 'task-create-edit-label-flags',
    templateUrl: './create-edit-label-flags.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None,

})

export class CreateEditLabelFlagsComponent {

    @Input()
    label_flag: LABEL_FLAG;

    is_edit_form = false;
    is_sys_admin = false;
    picked_company: Task.Company = null;

    @Output()
    result = new EventEmitter<Task.LabelFlags>();

    constructor() {
        language.load_translations(orders_translations)
        language.load_translations(label_flags_translations);
    }

    async init() {
        this.is_edit_form = this.label_flag.label_id ? true : false;
        this.is_sys_admin = await User.currentTypeIs(Task.USER_TYPE.SYSTEM_ADMIN);

        if (this.is_edit_form && this.label_flag.company_id && this.is_sys_admin) {
            try {
                const res = await TaskRoutes.companies.api_company_get_single(this.label_flag.company_id);
                this.picked_company = res.data;
            } catch (error) {
                console.error(error);
            }
        }
    }

    ngOnInit() {
        this.init();
    }

    async update_labels() {

    }

    async search_companies(search: string) {
        let res = await TaskRoutes.companies.api_company_search(
            { search: [search, Task.COMPANY_TYPE.MAIN], attributes: ["*I:+name+ +description+", "#=:company_type_id"] },
            { page_no: 1, page_size: 10 }
        );

        return res.data;
    }

    format_company_name(comp: Task.Company) {
        if (!comp) return "";
        return comp.name;
    }

    company_picker_change() {
        if (this.picked_company) {
            this.label_flag.company_id = this.picked_company.company_id
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["label_flag"]) {
            this.label_flag = { ...changes["label_flag"].currentValue };
        }
        this.update_labels();
        this.is_edit_form = !!this.label_flag.label_id;
    }

    done() {
        const payload = {
            ...this.label_flag,
            ...(this.is_sys_admin ? { company_id: this.label_flag.company_id } : {}),
        };

        this.result.emit(payload as Task.LabelFlags);
    }

    cancel() {
        this.result.emit(null);
    }
}
